// theme.js
import { createTheme } from '@mui/material/styles';

export const orangeTheme = createTheme({
  palette: {
    primary: {
      main: '#EA7F4A', // Material Orange
    },
  },
});
